import { Inbox as InboxIcon, Send, FileEdit, Clock, Trash2 } from "lucide-react";

export const FILTERS = ["tutti", "da_analizzare", "guasto", "morosita", "assemblea", "comunicazione_legale", "preventivi", "reclami", "fatture", "ordini", "assistenza", "contratti"];

export const FOLDERS = [
  { key: "inbox", label: "Posta in arrivo", icon: InboxIcon },
  { key: "sent", label: "Posta inviata", icon: Send },
  { key: "drafts", label: "Bozze", icon: FileEdit },
  { key: "scheduled", label: "Programmate", icon: Clock },
  { key: "trash", label: "Cestino", icon: Trash2 },
];

export const PRIORITIES = [
  { key: "alta", label: "Alta" },
  { key: "media", label: "Media" },
  { key: "bassa", label: "Bassa" },
];

export const SWIPE_THRESHOLD = 70;
export const PAGE = 50;

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
};

export const AVATAR_COLORS = ["#007BFF", "#34A853", "#EA4335", "#F59E0B", "#8E44AD", "#16A085", "#E67E22", "#2C3E50", "#0EA5E9", "#DB2777"];

export const avatarFor = (raw) => {
  const s = (raw || "").trim();
  const named = s.replace(/<[^>]*>/g, "").trim();
  const use = named || s.replace(/[<>]/g, "").trim() || "?";
  const initial = (use.match(/[a-zA-Z0-9]/)?.[0] || "?").toUpperCase();
  let h = 0;
  for (let i = 0; i < use.length; i++) h = (h * 31 + use.charCodeAt(i)) >>> 0;
  return { initial, color: AVATAR_COLORS[h % AVATAR_COLORS.length] };
};

export const threadKey = (subj) => {
  let s = (subj || "").trim();
  let prev;
  do { prev = s; s = s.replace(/^\s*(re|r|fwd|fw|i|ref|aw|rif)\s*:\s*/i, ""); } while (s !== prev);
  return s.toLowerCase();
};

export const stripHtml = (h) => (h || "").replace(/<style[\s\S]*?<\/style>/gi, " ").replace(/<[^>]+>/g, " ").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim();

export const buildHLRegex = (q) => {
  const terms = (q || "").trim().split(/\s+/)
    .map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
    .filter((t) => t.length >= 2);
  if (!terms.length) return null;
  try { return new RegExp(`(${terms.join("|")})`, "gi"); } catch { return null; }
};
